module.exports = __webpack_public_path__ + "static/media/surplus_dialog.d6c7ede3.svg";